import React from 'react'
import { IItemModel } from './ItemsApp'
import GenerateIcon from '../../components/GenerateIcon'

interface IProps {
    item: IItemModel,
}

export default function ItemCategory(props: IProps) {

    const { item } = props
    const { category_title, parent_category_title } = item

    if (!item){
        return <p>-</p>
    }

    return(
        <div className="item-current-location">
            <div className="content-of-item-current-location">
                <div className="item-single-current-location">
                    <div className="content-of-item-single-current-location">
                        <h4>{category_title}</h4>
                    </div>
                </div>
                {parent_category_title && (
                    <>
                        <GenerateIcon icon="arrow-right" />
                        <div className="item-single-current-location">
                            <div className="content-of-item-single-current-location">
                                <h4>{parent_category_title}</h4>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </div>
    )
}